import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessAdminHub, resolveAdminHubActorRole } from '../../lib/adminHubPermissions';
import { PortalPresenceReporter } from './PortalPresenceReporter';
import '../../styles/dem-theme-lab.css';

export function AdminHubShell() {
  const { portalAccess } = useAuth();
  const actorRole = resolveAdminHubActorRole(portalAccess);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('has-dock');
    root.style.removeProperty('--dock-clearance');
    root.style.removeProperty('--mobile-header-clearance');
    root.style.setProperty('--dock-clearance', '0px');
    root.style.setProperty('--mobile-header-clearance', '0px');
    return () => {
      root.style.removeProperty('--dock-clearance');
      root.style.removeProperty('--mobile-header-clearance');
    };
  }, []);

  if (!canAccessAdminHub(portalAccess) || !actorRole) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="app-shell app-shell--dock app-shell--admin-hub app-shell--dem-theme-lab">
      <PortalPresenceReporter portal="admin" />
      <div className="main">
        <div className="page">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
